<app-stats-card
  [transactionDataBundle]="statCardsTransactionDataBundle"
  [fiaAvailable]="statCardsFiaAvailable"
  [busy]="statCardsBusy"
  [previousWeekTransactionDataBundle]="prevWeekStatCardsTransactionDataBundle"
></app-stats-card>

<!--Grid row-->
<div class="row wow fadeIn mt-5">
  <!--Grid column-->
  <div class="col-md-12 mb-4">
    <!--Card-->
    <mdb-card>
      <!-- Card header -->
      <div class="card-header">{{ currentYear }} YTD Summary</div>

      <!--Card content-->
      <mdb-card-body>
        <div style="display: block; height: 40hv" *ngIf="!yearlySummaryBusy">
          <canvas
            mdbChart
            [chartType]="chart1Type"
            [datasets]="chartDatasets"
            [labels]="chartLabels"
            [colors]="chartColors"
            [options]="chartOptions"
            [legend]="false"
          >
          </canvas>
        </div>
        <!--Loading display-->
        <div class="text-center" *ngIf="yearlySummaryBusy">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </mdb-card-body>
    </mdb-card>
    <!--/.Card-->
  </div>
  <!--Grid column-->
</div>
<!--Grid row-->

<!-- <app-stats-card2></app-stats-card2> -->
